import styled from '@emotion/styled/macro';
import { margin, padding } from 'polished';

export const BreadcrumbList = styled.ol({
  ...margin(0),
  ...padding(0),
  listStyle: 'none'
});
